<!-- 详情页-标题 -->
<script lang="tsx">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DetailTitle',
  props: {
    title: {
      type: String,
      default: '',
    },

    tips: {
      type: String,
      default: '',
    },

    lineHeight: {
      type: Number,
      default: 32,
    },
  },

  render() {
    return (
      <div
        class='tw-flex tw-justify-between tw-mb-[10px]'
        style={{
          lineHeight: `${this.lineHeight}px`,
        }}
      >
        <div class='tw-flex tw-flex-[1_1_80%] tw-font-bold'>
          {this.$props.title && (
            <div class='tw-min-w-[110px]'>
              {this.$props.title}
            </div>
          )}

          {this.$slots.status && <div class='tw-mr-[10px]'>{this.$slots.status()}</div>}

          {this.tips && <span class='color-warning tw-pl-[10px] tw-text-[12px]'>{this.tips}</span>}
        </div>

        {this.$slots.default && <div class='tw-flex'>{this.$slots.default()}</div>}
      </div>
    );
  },
});
</script>
